import store from '../store'

export function getProjects() {	
	
	const state = store.getState()
	return state.projects
}

